export var EUserRoles;
(function (EUserRoles) {
    EUserRoles["public"] = "1";
    EUserRoles["unconfirmed"] = "2";
    EUserRoles["user"] = "3";
    EUserRoles["admin"] = "4";
})(EUserRoles || (EUserRoles = {}));
export const accessLevels = {
    public: [EUserRoles.public, EUserRoles.user, EUserRoles.admin, EUserRoles.unconfirmed],
    anon: [EUserRoles.public],
    unconfirmed: [EUserRoles.unconfirmed],
    loggedIn: [EUserRoles.user, EUserRoles.admin, EUserRoles.unconfirmed],
    user: [EUserRoles.user, EUserRoles.admin],
    admin: [EUserRoles.admin],
};
export var EUserLocalStorageKey;
(function (EUserLocalStorageKey) {
    EUserLocalStorageKey["userRole"] = "userRole";
    EUserLocalStorageKey["userId"] = "userId";
})(EUserLocalStorageKey || (EUserLocalStorageKey = {}));
